import { rawToScaledScore } from "./rawToScaledScore";

/**
 * Estimate section + total SAT scores from pillar-level raw correct
 *
 * pillars: [
 *   {
 *     id,
 *     pillarWeight,
 *     correctLow,
 *     correctEst,
 *     correctHigh
 *   }
 * ]
 *
 * section: "reading_writing" | "math"
 * maxQuestions: 66 | 54
 */
export const estimateTestScore = ({
  pillars,
  section,
  maxQuestions,
}) => {
  const weightedRaw = { low: 0, est: 0, high: 0 };

  pillars.forEach((p) => {
    const w = p.pillarWeight ?? 0;

    weightedRaw.low += w * p.correctLow;
    weightedRaw.est += w * p.correctEst;
    weightedRaw.high += w * p.correctHigh;
  });

  // Clamp to valid raw range
  const clamp = (x) =>
    Math.max(0, Math.min(maxQuestions, x));

  const rawLow = clamp(weightedRaw.low);
  const rawEst = clamp(weightedRaw.est);
  const rawHigh = clamp(weightedRaw.high);

  // 🔑 Convert each independently
  return {
    raw: {
      low: rawLow,
      est: rawEst,
      high: rawHigh,
    },
    scaled: {
      low: rawToScaledScore(rawLow, section, "lower"),
      est: rawToScaledScore(rawEst, section, "middle"),
      high: rawToScaledScore(rawHigh, section, "upper"),
    },
  };
};
